// extracted by css-extract-rspack-plugin
export default {"Spacer":"FoundationRewards_Spacer__njdfZ","Footer":"FoundationRewards_Footer__FsULW"};